<template>
  <v-container id="appointment" fluid tag="section">
    <filter-form :filter-form="filterForm" :users="users" />
    <v-card>
      <appointment-table
        :showModal="Boolean($route.query.showModal)"
        :filter-form="filterForm"
        :appointments="appointments"
        :users="users"
      />

      <!-- Phân trang -->
      <PaginateCursor
        :listLength="appointments.length"
        :currentPage="currentPage"
        :limit="limit"
        :paging="paging"
        @change-current-page="handleChangePage($event)"
      />

      <!--
      <v-row class="mt-4">
        <v-col cols="12" sm="6" />
        <v-col cols="12" sm="6">
          <v-pagination
            v-if="totalItem > limit"
            v-model="currentPage"
            class="justify-sm-end"
            :length="getTotalItem(totalItem)"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
      -->
    </v-card>
  </v-container>
</template>
<script>
import FilterForm from './components/FilterForm.vue';
import { formatDate } from '../../helpers/utils'
import AppointmentTable from './components/AppointmentTable';
import RepositoryFactory from '../../repositories/RepositoryFactory';
import { appointmentOptions } from '../../helpers/constants';
import PaginateCursor from "@/components/common/PaginateCursor.vue";

const AppointmentRepository = RepositoryFactory.get('appointment');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

export default {
  components: { FilterForm, AppointmentTable, PaginateCursor },

  data() {
    return {
      filterForm: {
        userIds: [],
        date: [],
        status: 'planning',
      },
      currentPage: 1,
      paging: {},
      limit: 10,
      totalItem: 0,
      loading: false,
      appointmentOptions,
      appointments: [],
      users: [],
      watchModule: ''
    };
  },
  async created() {
    if (this.$route.query.keyword) {
      this.filterForm.keyword = this.$route.query.keyword;
    }
    
    this.getAppointmentList();
    this.getUsers();

    Bus.$on('appointment-list-reload', () => {
      // window.location.href = '/users/appointment';
      this.getAppointmentList();
    });
    Bus.$on('appointment-list-filter', filterForm => {
      this.filterForm = filterForm || { date: [], userIds: [] };
      this.currentPage = 1;
      this.getAppointmentList();
    });

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          userIds: [],
          date: [],
          status: 'planning'
        }
        this.getUsers()
        Bus.$emit('appointment-list-filter', this.filterForm)
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('appointment-list-filter')
    Bus.$off('appointment-list-reload')
    this.watchModule()
  },

  methods: {
    async getAppointmentList(paramsPage = {}) {
      let valueDate = _.get(this.filterForm, 'date', []).map((d, index) => {
          return d ? formatDate(d) : ''
      })
      this.loading = true;
      let filterForm = _.cloneDeep(this.filterForm)
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        keyword: _.get(this.filterForm, 'keyword', ''),
        status: this.filterForm.status,
        date: valueDate,
        userIds: _.get(filterForm, 'userIds', []).filter(Boolean),
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
        ...paramsPage,
      };

      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const response = await AppointmentRepository.listV1(params);
      // loader.hide();
      this.appLoadingData(false)
      this.loading = false;
      if (response.success) {
        const dataList = response?.data?.dataList || [];
        this.appointments = dataList.map((a, index) => ({
          ...a,
          index: index + 1,
          rowspan: a.childCustomer.length > 0 ? a.childCustomer.length : 1,
          statusText: _.get(
            appointmentOptions.find(s => s.value === a.status),
            'text',
            ''
          ),
        }));
        this.totalItem = response.totalItem;
        this.paging = response?.data?.paging || {};
      }
    },

    // Nghe sự kiện thay đổi page
    handleChangePage(data) {
      this.currentPage = data.currentPage;
      delete data.currentPage;
      this.getAppointmentList(data);
    },

    async getUsers() {
      const res = await OrganizationMachineRepository.listUser({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      })

      if (res.success) {
        let listUsers = _.get(res, 'data', [])
        const groupUsers = [];
        listUsers.forEach(ministry => {
          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach(user => {
              groupUsers.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.users = groupUsers;
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    }
  }
};
</script>